import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import { motion } from "framer-motion";
import {
  // listTenantDetails,
  listTenantDetailsBySlugAction,
} from "../../actions/tenantActions";
import TenantSidebar from "./TenantSidebar";
import { backgroundLight, primary, white } from "../../utils/colors";
import HeaderMain from "./HeaderMain";
import useIsMobile from "../../hooks/useIsMobile";
import HeaderMainMobile from "./HeaderMainMobile";
import UserNoAccess from "../partials/UserNoAccess";
import Onboarding from "../onboarding/Onboarding";

const PrivateLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug } = useParams(); // ✅ Get slug from route

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const [onboardingOpen, setOnboardingOpen] = useState(false);
  const [status, setStatus] = useState("incomplete");

  // const tenantDetails = useSelector((state) => state.tenantDetails);
  // const { loading: loadingTenant, tenant } = tenantDetails;

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const { loading: loadingTenant, tenant, error } = tenantDetailsBySlug;

  // const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSideBarTiny, setIsSideBarTiny] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    // console.log("Slug changed to:", slug); // Log slug to check for changes
    if (userInfo && slug) {
      dispatch(listTenantDetailsBySlugAction(slug));
    } else {
      navigate("/login");
    }
  }, [dispatch, userInfo, slug]);

  useEffect(() => {
    if (tenant && tenant.onboarding) {
      setStatus(tenant.onboarding.status);
    }
  }, [tenant, status]);
  useEffect(() => {
    if (tenant && status === "incomplete") {
      setOnboardingOpen(true);
      document.body.style.overflow = "hidden";
    } else {
      setOnboardingOpen(false);
      document.body.style.overflow = "auto";
    }
  }, [tenant, status]);

  if (loadingTenant) {
    return (
      <Flex w="100%" h="100vh" align="center" justify="center">
        <Spinner size="lg" color={primary} />
      </Flex>
    );
  }

  if (error) {
    return (
      <>
        <HeaderMain />
        <Flex
          w="100%"
          h="100vh"
          align="center"
          justify="center"
          bg={backgroundLight}
        >
          <UserNoAccess pageName={error && error.clinicName} p="0q" />
        </Flex>
      </>
    );
  }

  return (
    <>
      <Onboarding
        tenant={tenant}
        open={onboardingOpen}
        setOpen={setOnboardingOpen}
      />
      {/* 
      <div className="w-full">
        <div className="w-full">asffas</div>
      </div> */}

      {!isMobile ? (
        <>
          <Flex w="100%" bg={backgroundLight}>
            <Flex
              direction="column"
              bg={backgroundLight}
              left={isSideBarTiny ? "80px" : "0px"}
              w={isSideBarTiny ? "calc(100% - 80px)" : "calc(100% - 0px)"}
              transition="all 0.2s"
              position="fixed"
              top="0"
              h="100%"
              overflowY="scroll"
              // bg="white"
              zIndex={10}
              as={motion.div}
              // pl="280px"
              exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
              initial={{ opacity: 0, x: 0, y: 0 }}
              animate={{
                opacity: 1,
                x: 0,
                y: 0,
                transition: { duration: 0.15 },
              }}
              id="main-content"
            >
              <Box
                as={motion.div}
                exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
                initial={{ opacity: 0, x: 0, y: 0 }}
                animate={{
                  opacity: 1,
                  x: 0,
                  y: 0,
                  transition: { duration: 0.15 },
                }}
                h="100vh"
                w="280px"
                position="fixed"
              >
                {tenant && (
                  <TenantSidebar
                    tenant={tenant}
                    userInfo={userInfo}
                    isSideBarTiny={isSideBarTiny}
                    setIsSideBarTiny={setIsSideBarTiny}
                  />
                )}
              </Box>

              <HeaderMain />

              <Box p="4" w="100%" pl="280px">
                <Outlet />{" "}
              </Box>
            </Flex>
          </Flex>
        </>
      ) : (
        <>
          <Flex
            direction="column"
            bg={white}
            w="100%"
            transition="all 0.2s"
            position="fixed"
            top="0"
            h="100%"
            overflowY="scroll"
            // bg="white"
            zIndex={10}
            as={motion.div}
            exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
            initial={{ opacity: 0, x: 0, y: 0 }}
            animate={{
              opacity: 1,
              x: 0,
              y: 0,
              transition: { duration: 0.15 },
            }}
            id="main-content"
          >
            <HeaderMainMobile />

            <Box p={["0", "4"]}>
              <Outlet />{" "}
            </Box>
          </Flex>
        </>
      )}
    </>
  );
};

export default PrivateLayout;
